<fieldset>
	<legend class="c-text c-text--gray u-osb-sm u-osb-md@up-to-md">{{ 'Booking.Payment_Method' | translate }}</legend>
	<div class="o-grid o-grid--wrap c-tabs c-tabs--xs">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--slim u-osb-sm" *ngFor="let banklink of vm.banklinks ; let $index=index">
			<input class="u-sr-only" type="radio" name="{{vm.name}}" id="{{vm.uid}}-{{$index}}" [value]="banklink" [(ngModel)]="vm.activeBanklink" (change)="vm.banklinkSelected()" [required]="vm.isRequired">
			<label for="{{vm.uid}}-{{$index}}" class="c-tabs__btn" [ngClass]="{'c-tabs__btn--active': vm.activeBanklink?.id == banklink.id}">
				<img src="{{vm.getBankLogo(banklink)}}" [ngStyle]="vm.getBankLogoStyles(banklink)" aria-hidden="true">
				<span class="u-sr-only">{{banklink.bankName}}</span>
			</label>
		</div>
	</div>
</fieldset>
